import React, { Component } from 'react';
import Form from '../../components/react-validation/components/form';
import Submit from '../../components/react-validation/components/submit';
import Input from '../../components/react-validation/components/input';
import {Modal} from 'react-bootstrap';
import * as Vali from '../../helper/validator-helper';
import PropTypes from 'prop-types';
import * as WorkOrderTypeActionType from '../constants';

export class AddEditWorkOrderType extends Component {
  static propTypes = {
    isOpenFormAddEdit: PropTypes.bool,
    isCreate: PropTypes.bool,
    show: PropTypes.bool,
    title: PropTypes.string,
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    item: PropTypes.object,
    errorMsg: PropTypes.array
  }
  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.show) {

      // this.form.resetForm(this.refs);

      if (nextProps.errorMsg.length && this.form) {
        this.form.showError(this.refs['name'], nextProps.errorMsg[0].error);
      }
    }

  }

  onSubmit(e) {

    let param = this.form.getValues();

    if (this.props.isCreate) {
      this.props.onSubmit(e, param,
        WorkOrderTypeActionType.CREATE_REQUEST_WORK_TYPE_ASYNC);
    } else {
      this.props.onSubmit(e,
        param,
        WorkOrderTypeActionType.UPDATE_REQUEST_WORK_TYPE_ASYNC);
    }

    e.preventDefault();
  }

  render() {
    let { name } = this.props.item;

    if (this.form) {
      name = this.form.getValues().name;
    }

    return <Modal show={this.props.show}>
      <div className='modal-header'>
        <button type='button' className='close' onClick={this.props.onCloseModal}>&times;</button>
        <h4 className='modal-title'>{this.props.title}</h4>
      </div>
      <Form ref={c => { this.form = c; }} onSubmit={this.onSubmit.bind(this)}>
        <div className='modal-body'>
          <Input type='hidden' name='id' ref='id' value={this.props.item.id} />
          <Input type='hidden' name='isActive' ref='isActive' value={this.props.item.isActive} />
          <div className='form-group'>
            <label>Work order type <span className='text-danger'>*</span></label>
            <Input type='text'
              autoFocus
              name='name'
              ref='name'
              value={name}
              placeholder='Work order type'
              className='form-control'
              max='200'
              maxLength='200'
              validations={[Vali.required, Vali.maxlength]} />
          </div>
        </div>
        <div className='modal-footer'>
          <Submit className='btn btn-primary btn-siteone'>Done</Submit>
        </div>
      </Form>
    </Modal>;
  }
}




// WEBPACK FOOTER //
// ./src/Work-Order-Type/Containers/add-edit-work-order-type.js